import { useState, useEffect } from "react";

const TypeWriterText = ({ text = "WOLFE VOM KATZENBERG", delay = 200, speed = 80 }) => {
  const [displayed, setDisplayed] = useState("");
  const [started, setStarted] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setStarted(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  useEffect(() => {
    if (!started) return;
    let i = 0;
    const interval = setInterval(() => {
      if (i < text.length) { setDisplayed(text.slice(0, i + 1)); i++; }
      else { setDone(true); clearInterval(interval); }
    }, speed);
    return () => clearInterval(interval);
  }, [started, text, speed]);

  return (
    <span className="text-[10px] tracking-[0.3em] text-[#D4AF37] block mb-3">
      {displayed}{!done && <span className="animate-pulse">|</span>}
    </span>
  );
};

export default TypeWriterText;
